import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ChannelEditModal from './ChannelEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  selectedChannel: state.channel.selectedChannel,
  status: state.modal.channelEditModal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_CHANNEL_EDIT, false),
  deleteStorageById: actions.storage.deleteStorageById,
  updateChannelById: actions.channel.updateChannelById,
  getChannelById: actions.channel.getChannelById
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelEditModal/index.js